module.exports = __webpack_public_path__ + "img/lead-bg.1a522b82.jpg";